module.exports = __webpack_public_path__ + "img/labscoreimportoutput.4ea85dc0.png";